import React from "react";
import "../../InvestigationManager/InvestigationManager.css";

const InvestigationResults = ({
  extraInvestigations,
  observations,
  setInvestigationId,
}) => {
  let FinalObjervaition = [];

  if (observations && observations.length > 0) {
    FinalObjervaition.push({
      investigation_name:
        observations[0]?.investigation_details?.investigation_name,
      data: observations,
      isHighlighted: true,
    });
  }

  if (extraInvestigations) {
    extraInvestigations.forEach((item) => {
      FinalObjervaition.push({
        investigation_name: item?.investigation_data?.investigation_name,
        data: extraInvestigations,
        isHighlighted: false,
      });
    });
  }

  return (
    <div className="mb-1">
      <div className="observation-details-list">
        <strong>Investigation Result</strong>
        <ul className="d-flex flex-row flex-wrap gap-2">
          {FinalObjervaition.map((investigation, index) => (
            <li
              key={index}
              className={`${investigation?.isHighlighted ? "bg-primary" : ""}`}
            >
              <a
                className={`${
                  investigation?.isHighlighted
                    ? "text-white highlight "
                    : "text-primary"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const matchingData = investigation?.data?.find(
                    (item) =>
                      item.investigation_data?.investigation_name ===
                      investigation.investigation_name
                  );

                  const investigationId = matchingData?.investigation_data?.id;
                  setInvestigationId(investigationId);

                  console.log(
                    `Clicked: ${investigation.investigation_name}, ID: ${investigationId}`
                  );
                }}
              >
                {investigation?.investigation_name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InvestigationResults;
